// extracted by mini-css-extract-plugin
export default {"cls1":"ihfkXNrqmujbxPTJ6HS7","cls2":"wX0yndgKoazbKoDF4JDp ihfkXNrqmujbxPTJ6HS7"};